import { render, staticRenderFns } from "./billing-plans-comparing-table-header.vue?vue&type=template&id=70de8f33&scoped=true&lang=pug"
import script from "./billing-plans-comparing-table-header.vue?vue&type=script&lang=js"
export * from "./billing-plans-comparing-table-header.vue?vue&type=script&lang=js"
import style0 from "./billing-plans-comparing-table-header.vue?vue&type=style&index=0&id=70de8f33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de8f33",
  null
  
)

export default component.exports